import React from 'react';
import { Box, Container, Typography, Link as MuiLink } from '@mui/material';
import {
  SITE_NAME,
  STREET,
  LOCALITY,
  CITY,
  STATE,
  POSTAL_CODE,
  GOOGLE_MAPS_EMBED_URL,
  GOOGLE_MAPS_PLACE_URL,
} from '../seo/seoConstants';

function AboutLocationMap() {
  const addressLine = `${SITE_NAME}, ${STREET}, ${LOCALITY}, ${CITY} — ${STATE} ${POSTAL_CODE}`;

  return (
    <Box
      component="section"
      aria-labelledby="about-location-heading"
      sx={{
        paddingY: { xs: '3rem', md: '4rem' },
        paddingX: { xs: '1rem', md: '2rem' },
        backgroundColor: '#f5f5f5',
      }}
    >
      <Container maxWidth="lg">
        <Typography
          id="about-location-heading"
          variant="h2"
          sx={{
            fontSize: 'clamp(1.8rem, 1.3654rem + 0.9065vw, 2rem)',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            marginBottom: '0.75rem',
            textAlign: 'center',
          }}
        >
          Visit us
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ textAlign: 'center', maxWidth: '720px', margin: '0 auto 1.5rem' }}
        >
          {addressLine}
        </Typography>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            paddingBottom: { xs: '65%', md: '45%' },
            height: 0,
            overflow: 'hidden',
            borderRadius: '8px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
            border: '1px solid rgba(0,0,0,0.06)',
          }}
        >
          <Box
            component="iframe"
            title={`Google Map — ${SITE_NAME} ${LOCALITY}, ${CITY}`}
            src={GOOGLE_MAPS_EMBED_URL}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 'none',
            }}
          />
        </Box>
        <Typography sx={{ textAlign: 'center', marginTop: '1rem' }}>
          <MuiLink
            href={GOOGLE_MAPS_PLACE_URL}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{ fontWeight: 600, color: '#00bf63' }}
          >
            Open this location in Google Maps
          </MuiLink>
        </Typography>
      </Container>
    </Box>
  );
}

export default AboutLocationMap;
